<template>
  <div class="home">
    <div class="top">
    </div>
    <div class="details">
      <div style="width: 90%;margin-left: 5%;padding-top: 60px">
        <div class="title">成员单位</div>
        <div style="display: flex">
          <div class="name">Members</div>
          <div style="width: 80%">
            <el-divider></el-divider>
          </div>
        </div>
        <div style="width: 100%;display: flex;align-items: center;justify-content: center">
          <div ref="pieChart" style="width: 700px; height: 400px;"></div>
        </div>
        <div v-for="item in dataList" :key="item.type" >
          <div style="display: flex" v-if="item.list.length>0">
            <img src="@/assets/tmp/address.svg" >
            <div style="padding-left: 20px">{{item.type}}相关单位</div>
          </div>
          <div class="members">
            <div style="display: flex;width: 33%;height: 60px;align-items: center" v-for="i in item.list" :key="i.id">
              <el-tooltip  placement="top" effect="light">
                <template slot="content">
                  <div style="width: 100%;text-align: center;font-weight: bold;font-size: 1.2rem">{{i.unitName}}</div>
                  <div style="height: 300px;width:  800px;display: flex;padding-top: 2rem">
                    <div style="width: 43%;margin-left: 5%">{{i.services}}</div>
                    <div style="width: 45%;margin-left: 5%;height: 300px">
                      <el-carousel>
                        <el-carousel-item v-for="image in i.filesUrl" :key="image.uid" >
                          <el-image :src="image.url" style="width:360px;height: 300px"></el-image>
                        </el-carousel-item>
                      </el-carousel>
                    </div>
                  </div>
                </template>
                <div style="display: flex;width: 100%;align-items: center">
                  <div style="height: 1.2rem;width: 1.2rem;border-radius: 0.6rem;background-color: #96b788"></div>
                  <div style="font-size: 1rem;margin-left: 60px">{{i.unitName}}</div>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts';
import {getUnitList} from "@/api/admin";
export default {

  // eslint-disable-next-line vue/multi-word-component-names
  name: 'index',
  data() {
    return {
      chartInstance: null,
      queryParams:{
        pageNum: 1,
        pageSize: 100,
      },
      dataList:[
        {type:'物流贸易',list:[]},
        {type:'数字经济',list:[]},
        {type:'城市发展',list:[]},
        {type:'绿色能源',list:[]},
        {type:'文教旅游',list:[]},
        {type:'金融资管',list:[]}
      ],
      option: {  // 这里是饼状图的配置项
        series: [{
          type: 'pie',
          data: [],
          radius: '70%'
        }],
      }
    }
  },
  mounted() {
    this.init()
    this.chartInstance = echarts.init(this.$refs.pieChart);

  },
  beforeRouteLeave(to, from, next) {
    // 保存滚动位置到 Vue Router 的 meta 字段
    if (this.$el) {
      from.meta.savedPosition = {
        x: window.pageXOffset,
        y: window.pageYOffset,
      };
    }
    next();
  },
  methods:{
    init(){
      getUnitList(this.queryParams).then(async res=>{
        const data=await  res.data.content
        let pieList=
          [ { value: 0, name: '物流贸易' },
            { value: 0, name: '数字经济' },
            { value: 0, name: '城市发展' },
            { value: 0, name: '绿色能源' },
            { value: 0, name: '文教旅游' },
            { value: 0, name: '金融资管' },
          ]

        for (let i = 0; i < data.length; i++) {
          switch (data[i].type){
            case 0: data[i].type='物流贸易';this.dataList[0].list.push(data[i]);pieList[0].value++;break
            case 1: data[i].type='数字经济';this.dataList[1].list.push(data[i]);pieList[1].value++;break
            case 2: data[i].type='城市发展';this.dataList[2].list.push(data[i]);pieList[2].value++;break
            case 3: data[i].type='绿色能源';this.dataList[3].list.push(data[i]);pieList[3].value++;break
            case 4: data[i].type='文教旅游';this.dataList[4].list.push(data[i]);pieList[4].value++;break
            case 5: data[i].type='金融资管';this.dataList[5].list.push(data[i]);pieList[5].value++;break
            default :break
          }
        }
        pieList=pieList.filter(item => item.value !== 0);
        this.option.series[0].data=pieList
        this.chartInstance.setOption(this.option);

      })
    }
  }
}
</script>

<style scoped>
.members{
  display: flex;
  font-size: 16px;
  padding-left: 40px;
  align-items: center;

  flex-wrap: wrap;
}
.title {
  margin-top: 40px;
  height: 50px;
  width: 120px;
  font-weight: 700;
  font-size: 24px;
  color: white;
  background-color: #234C9C;
  display: flex;
  align-items: center;
  justify-content: center;
}
.name{
  font-family: 'Arial Normal', 'Arial', sans-serif;
  font-weight: 400;
  font-style: normal;
  width: 20%;
  color: #AAAAAA;
  font-size: 24px;
  margin-top: 10px;
}
.home{
  width: 100%;
  background-color: #efefef;
}
.details{
  width: 70%;
  background-color: white;
  margin-left: 15%;
}
</style>
